<app-side-dialog (closeDialog)="onCloseClick()">
  <div dialogHeader>
    <div>
      <h2>
        {{ 'pages.creatorDetails.creatorInvitation.dialog.title' | translate: { name: data.creatorName } }}
      </h2>
    </div>
  </div>

  <div class="dialog-content" dialogContent>
    <form
      class="custom-form"
      [formGroup]="invitationForm"
      [class.custom-form-readonly]="invitationForm.disabled"
      (ngSubmit)="onSubmit()"
    >
      @if (creatorInvitation()) {
        <div class="flex items-center gap-2 mb-4">
          @if (creatorInvitation()?.createdUserId) {
            <span class="rounded-full bg-shikenso-success-base w-4 h-4"></span>
            <span>{{ 'pages.creatorDetails.creatorInvitation.dialog.accepted' | translate }}</span>
          } @else if (invitationExpired()) {
            <span class="rounded-full bg-shikenso-error-base w-4 h-4"></span>
            <span>
              {{
                'pages.creatorDetails.creatorInvitation.dialog.expired'
                  | translate: { expiryDate: (invitationExpiryDate() | date: 'dd.MM.yyyy HH:mm') }
              }}
            </span>
          } @else {
            <span class="rounded-full bg-shikenso-warning-base w-4 h-4"></span>
            <span>
              {{
                'pages.creatorDetails.creatorInvitation.dialog.notYetAccepted'
                  | translate: { expiryDate: (invitationExpiryDate() | date: 'dd.MM.yyyy HH:mm') }
              }}
            </span>
          }
        </div>
      }

      <mat-form-field class="w-full mb-2">
        <mat-label>{{ 'pages.creatorDetails.creatorInvitation.dialog.email' | translate }}</mat-label>
        <input matInput formControlName="email" />
        <mat-error [control]="invitationForm.get('email')">
          @if (invitationForm.get('email')?.errors?.['emailUsedForAnotherCreator']) {
            <button
              mat-icon-button
              type="button"
              class="mat-secondary-transparent-button-color !pb-2"
              (click)="onOpenErrorCreatorClick()"
            >
              <app-icon src="/icons/launch.svg" alt="Open creator in new tab" class="!w-4 !h-4" />
            </button>
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex-1 expandable-textarea-field w-full">
        <mat-label>{{ 'pages.creatorDetails.creatorInvitation.dialog.message' | translate }}</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          class="!flex !items-center"
          formControlName="message"
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="15"
        ></textarea>
        <mat-error [control]="invitationForm.get('message')" />
      </mat-form-field>

      <!-- Buttons -->
      <div class="flex items-center justify-between gap-6 mt-6">
        <button
          mat-flat-button
          type="button"
          color="danger"
          [disabled]="!creatorInvitation() || store.loading$()"
          (click)="onRevokeClick()"
        >
          @if (store.loading$()) {
            <app-dots-spinner />
          } @else {
            {{ 'pages.creatorDetails.creatorInvitation.dialog.revoke' | translate }}
          }
        </button>

        <button mat-flat-button type="submit" [disabled]="store.loading$() || creatorInvitation()?.createdUserId">
          @if (store.loading$()) {
            <app-dots-spinner />
          } @else {
            @if (creatorInvitation()) {
              {{ 'pages.creatorDetails.creatorInvitation.dialog.sendAnotherInvitation' | translate }}
            } @else {
              {{ 'pages.creatorDetails.creatorInvitation.dialog.sendInvitation' | translate }}
            }
          }
        </button>
      </div>
    </form>
  </div>
</app-side-dialog>
